import { useMemo } from "react";

import type { ISearchParamsAdapter } from "@amphore-dev/amphore-lib";
import { useSearchParams } from "react-router-dom";

/**
 * The filters context's URL adapter, on react-router. The lib's default
 * goes through window.history directly, which the data router never
 * sees: its location would drift from the address bar.
 */
export const useRouterSearchParams = (): ISearchParamsAdapter => {
	const [searchParams, setSearchParams] = useSearchParams();
	return useMemo(
		() => ({
			getParam: (key) => searchParams.get(key) ?? undefined,
			setParams: (updater, options) =>
				setSearchParams((prev) => updater(prev), {
					replace: options?.replace,
				}),
		}),
		[searchParams, setSearchParams]
	);
};
